import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetJobQueueListPagingAndFilterRequest } from '../models/request/jobQueue/GetJobQueueListPagingAndFilterRequest';

export class JobQueueService {
    /** Seçilen Nakliye kayıtlarının e-irsaliyesini arka plan kuyruğuna alır (her kayıt ayrı iş). */
    static async enqueueIrsaliye(_ambarIds: string[], _sendToGib: boolean) {
        try {
            var inputObj = {
                ambarIds: _ambarIds,
                sendToGib: _sendToGib
            };

            console.log('SERVICE CALL - enqueueIrsaliye', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/JobQueue/EnqueueIrsaliye', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getBatchStatus(_batchIds: string[]) {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/JobQueue/GetBatchStatus', { batchIds: _batchIds });

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getJobQueueListPagingAndFilter(inputObj: GetJobQueueListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - getJobQueueListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/JobQueue/GetJobQueueListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async retryJobs(_ids: string[]) {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/JobQueue/RetryJobs', { ids: _ids });

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async cancelJobs(_ids: string[]) {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/JobQueue/CancelJobs', { ids: _ids });

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}
